import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { loginWithOTP, ResendOTP } from "../../redux/reducer/authReducer"; // Adjust the path as needed
import CustomTitleWihBox from "../sharedComponents/customTitleWithBox";
import CustomInput from "./CustomInput";
import { LockOpenIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import useLanguageDirection from "../../hooks/useLanguageDirection";
export default function OTPForm() {
  const [otp, setOtp] = useState("");
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [countdown, setCountdown] = useState(0);

  const handleSubmit = (e) => {
    e.preventDefault();

    // Dispatch loginUser with email and password
    dispatch(loginWithOTP({ otp }))
      .unwrap()
      .then(() => {
        setTimeout(() => {
          window.location.href = "/my-account/dashboard";
        }, 1000);
      })
      .catch((error) => {
        console.error(error);
        alert(t("OTPFailed"));
      });
  };

  const handleResendOTPSubmit = (e) => {
    e.preventDefault();

    if (countdown > 0) return;

    const email = localStorage.getItem("email");

    dispatch(ResendOTP({ email }))
      .unwrap()
      .then(() => {
        alert(t("OTPSentSuccessfully"));
        setCountdown(60);
      })
      .catch((error) => {
        console.error(t("OTPResendFailed"), error);
        alert(t("OTPResendFailed"));
      });
  };

  const direction = useLanguageDirection();

  return (
    <div
      className="block p-8 mx-auto bg-white rounded-lg shadow-lg md:w-2/3 max-w-[700px]"
      dir={direction}
    >
      <CustomTitleWihBox title={t("OTP")} />
      <form onSubmit={handleSubmit}>
        <div className="mt-6 lg:mt-12 md:flex">
          <div className="mb-6 md:w-full md:mr-2">
            <CustomInput
              id="otp"
              label={t("OPT")}
              placeholder={t("EnteryourOTP")}
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              icon={<LockOpenIcon />}
              required
            />
          </div>
        </div>

        {/* Resend OTP with countdown */}
        <div
          onClick={handleResendOTPSubmit}
          className={`text-blue-600 cursor-pointer hover:underline  mb-6${
            countdown > 0 ? "pointer-events-none text-gray-400" : ""
          }`}
        >
          {countdown > 0
            ? `${t("ResendOTP")} (${countdown} ${t("s")})`
            : t("ResendOTP")}
        </div>

        <div className="flex justify-center mt-4 mb-6">
          <button
            type="submit"
            className="block w-full px-6 py-2 font-medium text-black uppercase transition duration-150 ease-in-out rounded-lg shadow-lg lg:text-lg lg:py-3 bg-custom-yellow hover:bg-primary-600 focus:outline-none"
          >
            {t("send")}
          </button>
        </div>
      </form>
    </div>
  );
}
